/**
 * Ref полосы, которая прокручивается вбок (график по дням или месяцам, месяцы года на телефоне): при первом показе элемент с
 * атрибутом `data-scroll-target` ставится по центру видимой части. Повторно — только при смене `key` (другой месяц, другой
 * период); между ними прокруткой управляет человек. Полоса, которая помещается целиком, не двигается.
 */
export function centerScrollTarget(key: string) {
  return (node: HTMLElement | null) => {
    if (node === null || node.dataset.centered === key) return
    const target = node.querySelector<HTMLElement>('[data-scroll-target]')
    if (target === null) return
    node.dataset.centered = key
    if (node.scrollWidth <= node.clientWidth) return
    const box = node.getBoundingClientRect()
    const item = target.getBoundingClientRect()
    node.scrollLeft = Math.max(0, item.left - box.left + node.scrollLeft - (box.width - item.width) / 2)
  }
}
